import SchaefferFrancisEmbed from "../images/SchaefferFrancisEmbed";
import Schaeffer from "../Thumbs/Schaeffer60.jpg";

const SchaefferFrancis = {
    objectName: 'SchaefferFrancis',
    firstName: 'Francis',
    lastName: 'Schaeffer',
    dates: '1912-1984',
    id: 'FS19121984',
    image: SchaefferFrancisEmbed,
    thumbImg: Schaeffer,
    quotes: [
    {
        tabHeading: `True Spirituality - Francis Schaeffer`,
        metaDescription: `Francis Schaeffer talks about True Spirituality from his 1982 Christian Manifesto Sermon.`,
        keywords: ["TrueLibertyNorth", ],
        title: 'Christian Manifesto Sermon',
        from: 'From: ',
        short: `"True Spirituality means that the Lord Jesus Christ is the Lord of all of life ..."`,
        date: '1982',
        id: 'FSCMTS1982',
        headTitle: `Francis Schaeffer - True Spirituality`,
        headDescription: `Francis Schaeffer talks about True Spirituality from his 1982 Christian Manifesto Sermon.`,
        content: [
                {bold: `Christian Manifesto Sermon - 1982`},                  
                {normal: `Now I want to say something with great force, right here. What I’ve been talking about, whether you know it or not, is True Spirituality. This is 
            True Spirituality. Spirituality, after you’re a Christian and have accepted Christ as savior, means that Christ is the Lord of all your life, and not just your 
            religious life, and if you make a dichotomy in these things, you are denying your Lord, his proper place, and I don’t care how many butterflies you have in your 
            stomach, you are poor spiritually.`}, 
                 {bold: `True Spirituality means that the Lord Jesus Christ is the Lord of all of life`, normal: `, and accept for the things that are specifically 
            told us in the bible are sinful and we set them aside, except for that, all of life is spiritual and all of life is equally spiritual, and that includes, as our 
            forefathers did, standing for these things of freedom, and standing for these things of human life, and all these other matters that are so crucial, if indeed 
            this living God does exist as we know that he does exist.`}
        ],
        considerations: [
            {
                name: '',
                title: 'Thomas Jefferson',
                date: '',
                content: [`I predict future happiness for Americans if they can prevent the government from wasting the labors of the people under the pretense of taking 
            care of them.`]
            },
            {
                name: '',
                title: 'John Adams',
                date: '',
                content: [`You will never know how much it cost the present generation to preserve your freedom! I hope you will make a good use of it.`]
            }
        ]
    }, {
        tabHeading: `Two Reasons Christians Have Failed`,
        metaDescription: `Francis Schaeffer gives 2 reasons the Christian church has failed over the last 40 years.`,
        keywords: ["TrueLibertyNorth", ],
        title: 'Christian Manifesto Sermon',
        from: 'From: ',
        short: `"Two Specific Reasons the church has failed to meet its obligation in these last 40 years ..."`,
        date: '1982',
        id: 'FSCM2reasons1982',
        headTitle: `Francis Schaeffer - Two Reasons Christians Have Failed`,
        headDescription: `Francis Schaeffer talks about True Spirituality from his 1982 Christian Manifesto Sermon.`,
        content: [
            {bold: `Christian Manifesto Sermon - 1982`},                  
            {normal: `I think the church has failed to meet its obligation in these last 40 years for two specific reasons. The first is this false, false truncated 
        view of spirituality that doesn’t see true spirituality touching all of life. And the other thing is, too many Christians, whether the doctors, lawyers, pastors, 
        evangelists, whatever they are, too many of them afraid to really speak out because they did not want to rock the boat, for their own project. And I’m convinced 
        that these two reasons, both of which are a tragedy and really horrible for the Christian, both of them, the two together are an explanation why we have walked 
        the road we have walked in the last 40 years.`},
            {normal: `You must understand, it’s going to cost you to take a stand in these things. There are doctors who are going to get kicked out of hospitals because 
        they refuse to perform abortions. There are nurses who see a little sign on a crib, do not feed, and they feed and they’re fired. There’s a cost. There’s a cost. 
        But I’d ask you, I’d ask you, what is loyalty to Christ worth to you? What is loyalty to Christ worth to you? How much do you believe this is true? Why are you a 
        Christian? Are you a Christian because for some lesser reason or are you a Christian because you know this is the truth of reality? And then how much do you love 
        the Lord Jesus Christ? How much are you willing to pay the price for loyalty to the Lord Jesus? `}, 
                
        ],
        considerations: [
            {
                name: '',
                title: 'Thomas Jefferson',
                date: '',
                content: [`I predict future happiness for Americans if they can prevent the government from wasting the labors of the people under the pretense of taking 
            care of them.`]
            },
            {
                name: '',
                title: 'John Adams',
                date: '',
                content: [`You will never know how much it cost the present generation to preserve your freedom! I hope you will make a good use of it.`]
            }
        ]
    }    
]};

export default SchaefferFrancis;